import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Container, Row } from "reactstrap";

//Import Icons
import FeatherIcon from "feather-icons-react";

// import images
import tasks from "../../assets/images/property-management/myclassic2.png";
import rentalApplications from "../../assets/images/property-management/myclassic6.png";
import propertyForRent from "../../assets/images/ai-generated/property-for-rent.jpeg";
import analytics from "../../assets/images/property-management/classic.png";
import inventoryManagement from "../../assets/images/property-management/inventory-management.png";
import leaseManagement from "../../assets/images/property-management/lease-analytics.png";
import communications from "../../assets/images/property-management/myclassic5.png";

export default class HowItWorks extends Component {
  componentDidMount() {
    document.body.classList = "";
    // document.querySelector(".shoppingbtn").classList.add("btn-primary");
    window.addEventListener("scroll", this.scrollNavigation, true);
  }

  // Make sure to remove the DOM listener when the component is unmounted.
  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollNavigation, true);
  }

  scrollNavigation = () => {
    var doc = document.documentElement;
    const navBar = document.getElementById("topnav");
    var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    if (navBar != null) {
      if (top > 80) {
        navBar.classList.add("nav-sticky");
      } else {
        navBar.classList.remove("nav-sticky");
        document.querySelector(".shoppingbtn").classList.add("btn-primary");
        document.querySelector(".shoppingbtn").classList.remove("btn-light");
        document.querySelector(".settingbtn").classList.add("btn-soft-primary");
      }
    }
  };

  render() {
    return (
      <React.Fragment>
        <section className="bg-half-100 bg-light d-table w-100">
          <Container>
            {/* <Row className="mt-5 justify-content-center">
              <Col lg={12} className="text-center">
                <div className="pages-heading">
                  <h4 className="title mb-0"> How it works </h4>
                </div>
              </Col>
            </Row> */}
            <div className="position-breadcrumb">
              <nav aria-label="breadcrumb" className="d-inline-block">
                <ul className="breadcrumb rounded shadow mb-0 px-4 py-2">
                  <li className="breadcrumb-item"><Link to="/">Zenstrin</Link></li>{" "}
                  <li className="breadcrumb-item"><Link to="/property-management-as-a-service">Property Management as a Service</Link></li>{" "}
                  <li className="breadcrumb-item active" aria-current="page">How it works</li>
                </ul>
              </nav>
            </div>
          </Container>
        </section>
        <div className="position-relative">
          <div className="shape overflow-hidden text-white">
            <svg
              viewBox="0 0 2880 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
                fill="currentColor"
              ></path>
            </svg>
          </div>
        </div>
        <section className="section">
          <Container>
            <Row className="justify-content-center">
              <Col lg={9}>
                <div className="main-icon rounded-pill text-primary text-center mt-4 pt-2">
                  <i>
                    <FeatherIcon icon="star" className="fea icon-md-sm" style={{ color: "#fbcf97" }} />
                  </i>
                </div>
                <div className="timeline-page pt-2 position-relative">
                  <div className="timeline-item mt-4">
                    <Row>
                      <Col lg={6} md={6} sm={6}>
                        {/* <div className="duration date-label-left border rounded p-2 px-4 position-relative shadow">
                          2002
                        </div> */}
                      </Col>
                      <Col lg={6} md={6} sm={6}>
                        <Card className="event event-description-right rounded shadow border-0 overflow-hidden float-start">
                          <img src={propertyForRent} className="img-fluid" alt="" />
                          <CardBody>
                            <h5 className="mb-0 text-capitalize">List & Advertise Your Property</h5>
                            <p className="mt-3 mb-0 text-muted">
                              Send us your property details and we’ll handle the rest. We’ll list your rentals on major property portals and market them to qualified tenants.
                            </p>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </div>

                  <div className="timeline-item mt-4">
                    <Row>
                      <Col lg={6} md={6} sm={6} className="order-sm-1 order-2">
                        <Card className="event event-description-left rounded shadow border-0 overflow-hidden float-start">
                          <img src={rentalApplications} className="img-fluid" alt="" />
                          <CardBody>
                            <h5 className="mb-0 text-capitalize">
                              Tenant Discovery & Applications
                            </h5>
                            <p className="mt-3 mb-0 text-muted">
                              We manage all tenant inquiries, process rental applications, and collect key tenant information on your behalf—completely hands-off for you.                            </p>
                          </CardBody>
                        </Card>
                      </Col>
                      <Col lg={6} md={6} sm={6} className="order-sm-2 order-1">
                        {/* <div className="duration duration-right rounded border p-2 px-4 position-relative shadow text-start">
                          2006
                        </div> */}
                      </Col>
                    </Row>
                  </div>

                  <div className="timeline-item mt-4">
                    <Row>
                      <Col lg={6} md={6} sm={6}>
                        {/* <div className="duration date-label-left border rounded p-2 px-4 position-relative shadow">
                          2012
                        </div> */}
                      </Col>
                      <Col lg={6} md={6} sm={6}>
                        <Card className="event event-description-right rounded shadow border-0 overflow-hidden float-start">
                          <img src={rentalApplications} className="img-fluid" alt="" />
                          <CardBody>
                            <h5 className="mb-0 text-capitalize">Tenant Screening & Compliance</h5>
                            <p className="mt-3 mb-0 text-muted">
                              Our team conducts thorough tenant screening—background checks, credit checks, and references—while ensuring full compliance with local regulations.
                            </p>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </div>

                  <div className="timeline-item mt-4">
                    <Row>
                      <Col lg={6} md={6} sm={6} className="order-sm-1 order-2">
                        <Card className="event event-description-left rounded shadow border-0 overflow-hidden float-start">
                          <img src={leaseManagement} className="img-fluid" alt="" />
                          <CardBody>
                            <h5 className="mb-0 text-capitalize">Lease Creation & Move-In Inventory</h5>
                            <p className="mt-3 mb-0 text-muted">
                              We prepare lease agreements, handle digital signing, and record a detailed inventory of property items to document their condition before move-in.
                            </p>
                          </CardBody>
                        </Card>
                      </Col>
                      <Col lg={6} md={6} sm={6} className="order-sm-2 order-1">
                        {/* <div className="duration duration-right rounded border p-2 px-4 position-relative shadow text-start">
                          2013
                        </div> */}
                      </Col>
                    </Row>
                  </div>

                  <div className="timeline-item mt-4">
                    <Row>
                      <Col lg={6} md={6} sm={6}>
                        {/* <div className="duration date-label-left border rounded p-2 px-4 position-relative shadow">
                          2002
                        </div> */}
                      </Col>
                      <Col lg={6} md={6} sm={6}>
                        <Card className="event event-description-right rounded shadow border-0 overflow-hidden float-start">
                          <img src={analytics} className="img-fluid" alt="" />
                          <CardBody>
                            <h5 className="mb-0 text-capitalize">Rent Collection & Automated Reminders</h5>
                            <p className="mt-3 mb-0 text-muted">
                              We collect rent payments directly and send automated reminders to tenants. You’ll get your funds deposited without lifting a finger.
                            </p>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </div>

                  <div className="timeline-item mt-4">
                    <Row>
                      <Col lg={6} md={6} sm={6} className="order-sm-1 order-2">
                        <Card className="event event-description-left rounded shadow border-0 overflow-hidden float-start">
                          <img src={communications} className="img-fluid" alt="" />
                          <CardBody>
                            <h5 className="mb-0 text-capitalize">
                              Tenant Communication Management
                            </h5>
                            <p className="mt-3 mb-0 text-muted">
                              All tenant queries, complaints, and notices are handled by our team. We keep tenants happy while keeping you stress-free.                          </p>
                          </CardBody>
                        </Card>
                      </Col>
                      <Col lg={6} md={6} sm={6} className="order-sm-2 order-1">
                        {/* <div className="duration duration-right rounded border p-2 px-4 position-relative shadow text-start">
                          2006
                        </div> */}
                      </Col>
                    </Row>
                  </div>

                  <div className="timeline-item mt-4">
                    <Row>
                      <Col lg={6} md={6} sm={6}>
                        {/* <div className="duration date-label-left border rounded p-2 px-4 position-relative shadow">
                          2012
                        </div> */}
                      </Col>
                      <Col lg={6} md={6} sm={6}>
                        <Card className="event event-description-right rounded shadow border-0 overflow-hidden float-start">
                          <img src={tasks} className="img-fluid" alt="" />
                          <CardBody>
                            <h5 className="mb-0 text-capitalize">Maintenance & Service Provider Coordination</h5>
                            <p className="mt-3 mb-0 text-muted">
                              Tenants submit maintenance requests directly to us. We coordinate with trusted service providers, get quotes, and oversee the work from start to finish.
                            </p>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </div>

                  <div className="timeline-item mt-4">
                    <Row>
                      <Col lg={6} md={6} sm={6} className="order-sm-1 order-2">
                        <Card className="event event-description-left rounded shadow border-0 overflow-hidden float-start">
                          <img src={inventoryManagement} className="img-fluid" alt="" />
                          <CardBody>
                            <h5 className="mb-0 text-capitalize">Inventory & Property Condition Tracking</h5>
                            <p className="mt-3 mb-0 text-muted">
                              Track property items with before-and-after inspections. We update inventory records at move-in and move-out to protect your assets.
                            </p>
                          </CardBody>
                        </Card>
                      </Col>
                      <Col lg={6} md={6} sm={6} className="order-sm-2 order-1">
                        {/* <div className="duration duration-right rounded border p-2 px-4 position-relative shadow text-start">
                          2013
                        </div> */}
                      </Col>
                    </Row>
                  </div>

                  <div className="timeline-item mt-4">
                    <Row>
                      <Col lg={6} md={6} sm={6}>
                        {/* <div className="duration date-label-left border rounded p-2 px-4 position-relative shadow">
                          2012
                        </div> */}
                      </Col>
                      <Col lg={6} md={6} sm={6}>
                        <Card className="event event-description-right rounded shadow border-0 overflow-hidden float-start">
                          <img src={analytics} className="img-fluid" alt="" />
                          <CardBody>
                            <h5 className="mb-0 text-capitalize">Detailed Financial & Performance Reporting</h5>
                            <p className="mt-3 mb-0 text-muted">
                              Get monthly financial reports, expense tracking, and insights into your portfolio’s performance—all prepared for you.
                            </p>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}
